// Dependencies
import styled from 'styled-components';

const BannerStyles = styled.section`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column wrap;
  padding: 2rem 0;
  text-align: center;
  background-color: var(--color-${(props) => props?.bgColor});

  > * {
    z-index: 1;
  }

  .logo {
    max-width: 10rem;
    margin-bottom: 2.5rem;
  }

  .heading,
  .text {
    color: ${(props) =>
      props?.bgColor === 'bark' || props?.bgColor === 'charcoal'
        ? '#fff'
        : 'var(--color-charcoal)'};
  }

  .heading {
    max-width: 25rem;
    margin: 0 auto
      ${(props) => (props?.text || props?.buttons ? '1.5rem' : '0')} auto;
  }

  .text {
    max-width: 40rem;
    margin: 0 auto;

    p {
      font-size: 1rem;
    }
  }

  .btn-group {
    margin: 1rem 0 0;
  }

  @media (min-width: 768px) {
    padding: 4rem 0;

    .logo {
      max-width: 16rem;
    }

    .heading {
      font-size: 1.438rem;
      max-width: 36rem;
    }

    .text {
      max-width: 49.5rem;

      p {
        font-size: 1.3rem;
      }
    }

    .btn-group {
      margin: 3.5rem 0 0;
    }
  }
`;

export default BannerStyles;
